import { AdditiveBlending, CameraHelper, OrthographicCamera, RawShaderMaterial, WebGLRenderTarget } from 'three';

import { lisa } from '../../Lisa.js';
import { EVENTS, LAYERS } from '../../constants.js';

import fs from './fragment.fs?hotShader';
import vs from './vertex.vs?hotShader';

class ScreenGlow extends RawShaderMaterial {
	constructor(config, caller) {
		super({
			uniforms: {
				tMap: { value: null },
			},
			transparent: true,
			blending: AdditiveBlending,
		});

		caller.layers.disableAll();
		caller.layers.disable(LAYERS.OUTSCREEN);

		this.#createOrthoCam(caller);

		lisa.state.on(EVENTS.RENDER, this.onRender);
		lisa.state.on(EVENTS.DETACH, this.#onDetach);

		vs.use(this);
		fs.use(this);
	}

	#createOrthoCam = (caller) => {
		this.glowRenderTarget = new WebGLRenderTarget(128, 128, {
			samples: 1,
		});
		this.uniforms.tMap.value = this.glowRenderTarget.texture;

		this.orthoCam = new OrthographicCamera(-0.7, 0.7, 0.7, -0.7, 0.001, 10);
		this.orthoCam.position.set(0, 0.4, 4);
		caller.add(this.orthoCam);
		// lisa.scene.add(new CameraHelper(this.orthoCam));
		this.orthoCam.layers.disableAll();
		this.orthoCam.layers.enable(LAYERS.SCREEN);
	};

	onRender = () => {
		if (this.orthoCam) {
			lisa.renderer.setRenderTarget(this.glowRenderTarget);

			lisa.renderer.clear();
			lisa.renderer.render(lisa.scene, this.orthoCam);
			lisa.renderer.setRenderTarget(null);
		}
	};
	#onDetach = () => {
		lisa.state.off(EVENTS.RENDER, this.onRender);
		lisa.state.off(EVENTS.DETACH, this.#onDetach);
	};
}

export default ScreenGlow;
